import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateOrganizationBrand = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, data }) => {
            return client.put(
                replaceParameters(ORGANIZATION.DETAILS.url, { organizationId: uuid }),
                data
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateOrganizationBrand;